/**
 * Check if the current environment is author mode
 */

// eslint-disable-next-line import/prefer-default-export
export const IS_AUTHOR_MODE = window.location.hostname.includes('adobeaemcloud.com');

export const SECTION_STYLES = {
  background: [
    {
      name: 'dark',
      value: 'nsw-section--brand-dark',
    },
    {
      name: 'light',
      value: 'nsw-section--brand-light',
    },
    {
      name: 'supplementary',
      value: 'nsw-section--brand-supplementary',
    },
    {
      name: 'off white',
      value: 'nsw-section--off-white',
    },
  ],
};

export const SEARCH_TRACKING_API = 'https://search-test.education.nsw.gov.au/api/tracking/v1/track';
